import { defineLocale } from "../../registry";

const links = defineLocale({
  ru: {
    "links.pairs.title": "Хорошо сочетается с",
    "links.pairs.hint":
      "Связывайте только другие Pick: города и страны здесь выбрать нельзя",
    "links.pairs.empty": "Связанных Pick пока нет",
    "links.pairs.add": "Добавить",
    "links.pairs.addAria": "Добавить {title}",
    "links.pairs.added": "Уже добавлен",
    "links.pairs.remove": "Убрать",
    "links.pairs.removeAria": "Убрать {title}",
    "links.pairs.search.label": "Найти Pick",
    "links.pairs.search.placeholder": "Название Pick",
    "links.pairs.search.submit": "Найти",
    "links.pairs.search.results": "Результаты поиска",
    "links.pairs.search.empty": "Pick не найдены",
  },
  en: {
    "links.pairs.title": "Pairs well with",
    "links.pairs.hint":
      "Link other Picks only: cities and countries cannot be chosen here",
    "links.pairs.empty": "No related Picks yet",
    "links.pairs.add": "Add",
    "links.pairs.addAria": "Add {title}",
    "links.pairs.added": "Already added",
    "links.pairs.remove": "Remove",
    "links.pairs.removeAria": "Remove {title}",
    "links.pairs.search.label": "Find a Pick",
    "links.pairs.search.placeholder": "Title of a Pick",
    "links.pairs.search.submit": "Search",
    "links.pairs.search.results": "Search results",
    "links.pairs.search.empty": "No Picks found",
  },
});

export default links;
